export class NativeStreamScalarTransformColumn {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "expr",
            "baseName": "expr",
            "type": "string",
            "format": ""
        },
        {
            "name": "overwrite",
            "baseName": "overwrite",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamScalarTransformKind",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamScalarTransformColumn.attributeTypeMap;
    }
    constructor() {
    }
}
